import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import PrivateMainContainer from "./Containers/PrivateMainContainer";
import AuthContainer from "./Containers/AuthContainer";
import {Switch} from "react-router";
import PublicMainContainer from "./Containers/PublicMainContainer";
import Export from "./Components/Export";
import ExportClientFile from "./Components/ExportClientFile";
import ExportClientFilePublic from "./Components/ExportClientFilePublic";
import ExportNote from "./Components/ExportNote";
import PrintCharge from "./Components/PrintCharge";
import PrintPayment from "./Components/PrintPayment";
import CustomerStartSignDocument from "./Components/CustomerStartSignDocument";
import CustomerCompleteSignDocument from "./Components/CustomerCompleteSignDocument";

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path={"/m/share/:clientId"}>
                    <ExportClientFilePublic/>
                </Route>
                <Route exact path={"/m/export-client-file/:clientId"}>
                    <ExportClientFile/>
                </Route>
                <Route exact path={"/m/export/:documentId"}>
                    <Export/>
                </Route>
                <Route exact path={"/m/export-note/:noteId"}>
                    <ExportNote/>
                </Route>
                <Route exact path={"/m/receipt/clients/:clientId/charges/:chargeId"}>
                    <PrintCharge/>
                </Route>
                <Route exact path={"/m/receipt/clients/:clientId/payments/:paymentId"}>
                    <PrintPayment/>
                </Route>
                <Route path={"/c/sign-document/:documentId/profile/:profileId/key/:keyId/refer-to/:referTo"}>
                    <CustomerStartSignDocument/>
                </Route>
                <Route path={"/c/complete-document/:documentId"}>
                    <CustomerCompleteSignDocument/>
                </Route>
                <Route path={"/m"}>
                    <PrivateMainContainer/>
                </Route>
                <Route path={"/a"}>
                    <AuthContainer/>
                </Route>
                <Route path={"/"}>
                    <PublicMainContainer/>
                </Route>
            </Switch>
        </Router>
    );
}

export default App;
